module.exports = __webpack_public_path__ + "media/Audio16_b.c2ee0dcd.wav";